import React from "react";
import { Badge, truncateAddress } from "../shared";

function formatDate(dateStr) {
  if (!dateStr) return "—";
  const d = new Date(dateStr);
  return d.toLocaleDateString("en-US", { month: "short", day: "numeric" });
}

function formatRelative(dateStr) {
  if (!dateStr) return "Never";
  const diff = Date.now() - new Date(dateStr).getTime();
  const mins = Math.floor(diff / 60000);
  if (mins < 1) return "Just now";
  if (mins < 60) return `${mins} min ago`;
  const hours = Math.floor(mins / 60);
  if (hours < 24) return `${hours}h ago`;
  const days = Math.floor(hours / 24);
  return `${days}d ago`;
}

export default function KeyRow({ keyItem, onRevoke, variant = "row" }) {
  // Backend uses snake_case: prefix, wallet_index, wallet_address, created_at, last_used_at
  const prefix = keyItem.prefix || keyItem.keyPrefix || "";
  const walletIdx = keyItem.wallet_index ?? keyItem.walletIndex ?? 0;
  const walletAddr = keyItem.wallet_address || keyItem.walletAddress;
  const createdAt = keyItem.created_at || keyItem.createdAt;
  const lastUsedAt = keyItem.last_used_at || keyItem.lastUsedAt;
  const expiresAt = keyItem.expires_at || keyItem.expiresAt;
  const allowedIps = keyItem.allowed_ips || keyItem.ipAllowlist || [];
  const allowedTools = keyItem.allowed_tools || keyItem.toolRestrictions || [];
  // Backend doesn't return status — keys in the list are always active (revoked keys are deleted)
  const status = keyItem.status || "active";
  // Display prefix without trailing "..." since backend already includes it
  const displayPrefix = prefix.endsWith("...") ? prefix : `${displayPrefix}`;

  const hasRestrictions = !!(expiresAt || allowedIps.length || allowedTools.length);

  if (variant === "card") {
    return (
      <div className="mcp-key-card">
        <div className="mcp-key-card-header">
          <span className="mcp-key-card-name">{keyItem.name}</span>
          <Badge variant={status === "active" ? "green" : "red"}>
            {status === "active" ? "Active" : "Revoked"}
          </Badge>
        </div>
        <div className="mcp-key-card-body">
          <div className="mcp-key-card-row">
            <span className="mcp-muted">Key</span>
            <code className="mcp-key-prefix">{displayPrefix}</code>
          </div>
          <div className="mcp-key-card-row">
            <span className="mcp-muted">Wallet</span>
            <span>
              #{walletIdx} ({truncateAddress(walletAddr)})
            </span>
          </div>
          <div className="mcp-key-card-row">
            <span className="mcp-muted">Created</span>
            <span>{formatDate(createdAt)}</span>
          </div>
          <div className="mcp-key-card-row">
            <span className="mcp-muted">Last used</span>
            <span>{formatRelative(lastUsedAt)}</span>
          </div>
          {hasRestrictions && (
            <Badge variant="blue">Restricted</Badge>
          )}
        </div>
        {status === "active" && (
          <div className="mcp-key-card-footer">
            <button
              type="button"
              className="mcp-btn-danger-sm"
              onClick={() => onRevoke(keyItem)}
            >
              Revoke
            </button>
          </div>
        )}
      </div>
    );
  }

  return (
    <tr className="mcp-key-row">
      <td className="mcp-key-cell">{keyItem.name}</td>
      <td className="mcp-key-cell">
        <code className="mcp-key-prefix">{displayPrefix}</code>
      </td>
      <td className="mcp-key-cell">
        #{walletIdx} ({truncateAddress(walletAddr)})
      </td>
      <td className="mcp-key-cell">{formatDate(createdAt)}</td>
      <td className="mcp-key-cell">{formatRelative(lastUsedAt)}</td>
      <td className="mcp-key-cell">
        <Badge variant={status === "active" ? "green" : "red"}>
          {status === "active" ? "Active" : "Revoked"}
        </Badge>
        {hasRestrictions && (
          <Badge variant="blue">Restricted</Badge>
        )}
      </td>
      <td className="mcp-key-cell">
        {status === "active" && (
          <button
            type="button"
            className="mcp-btn-danger-sm"
            onClick={() => onRevoke(keyItem)}
          >
            Revoke
          </button>
        )}
      </td>
    </tr>
  );
}
